import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EvaluationListItem from "./EvaluationListItem";

const DisciplineColor = styled.div`
  width: 10px;
  height: 100%;
  background: ${props => props.color};
`;

const DisciplineCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding: 0 !important;
  flex-grow: 1;
`;

const DisciplineContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  width: 100%;
  margin: 14px 24px;
`;

const DisciplineName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const DisciplineTitle = styled.span`
  font-size: 16px;
  color: #000;
  margin: 3px 0;
`;

const DisciplineSubtitle = styled.span`
  font-size: 12px;
  color: ${props => props.color};
  margin: 3px 0;
`;

const DisciplineAverage = styled.span`
  color: ${props => props.color};
  font-size: 24px;
  font-weight: bold;
`;

const AccordionSummary = styled(ExpansionPanelSummary)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 !important;
  padding: 0 24px 0 0 !important;
`;

const AccordionDetails = styled(ExpansionPanelDetails)`
  display: flex;
  flex-direction: column;
  padding: 0 !important;
`;

const AdmissionStatus = styled.div`
  color: ${props => props.color};
  font-weight: bold;
  font-size: 14px;
`;

const AccordionSummaryStyle = withStyles({
  content: {
    margin: 0
  },
  expanded: {
    margin: "0 !important"
  }
})(AccordionSummary);

const ExpansionPanelStyle = withStyles({
  expanded: {
    margin: "0"
  }
})(ExpansionPanel);

const DisciplineListItem = ({
  discipline,
  average,
  description,
  color,
  onClick,
  evaluations,
  teacher,
  admissionStatus,
  expandedItem
}) => {
  const [expanded, setExpanded] = useState(expandedItem);
  return (
    <ExpansionPanelStyle
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
    >
      <AccordionSummaryStyle
        expandIcon={
          !onClick && evaluations && !!evaluations.length && <ExpandMoreIcon />
        }
      >
        <DisciplineCard onClick={onClick || null}>
          <DisciplineColor color={color} />
          <DisciplineContent>
            <DisciplineName>
              <DisciplineTitle>{discipline}</DisciplineTitle>
              {teacher && <DisciplineSubtitle>{teacher}</DisciplineSubtitle>}
              {description && (
                <DisciplineSubtitle>{description}</DisciplineSubtitle>
              )}
            </DisciplineName>
            {admissionStatus && (
              <AdmissionStatus color={admissionStatus.color}>
                {admissionStatus.value}
              </AdmissionStatus>
            )}
            <DisciplineAverage color={average.color}>
              {average.value}
            </DisciplineAverage>
          </DisciplineContent>
        </DisciplineCard>
      </AccordionSummaryStyle>
      <AccordionDetails>
        {evaluations ? (
          evaluations.map(evaluation => {
            return (
              <EvaluationListItem key={evaluation.id} evaluation={evaluation} />
            );
          })
        ) : (
          <DisciplineSubtitle>Nenhuma avaliação disponível</DisciplineSubtitle>
        )}
      </AccordionDetails>
    </ExpansionPanelStyle>
  );
};

DisciplineListItem.propTypes = {
  discipline: PropTypes.string.isRequired,
  description: PropTypes.string,
  color: PropTypes.string.isRequired,
  teacher: PropTypes.string,
  onClick: PropTypes.func,
  evaluations: PropTypes.arrayOf(),
  average: PropTypes.shape({
    color: PropTypes.string,
    value: PropTypes.string
  }),
  admissionStatus: PropTypes.shape({
    color: PropTypes.string,
    value: PropTypes.string
  }),
  expandedItem: PropTypes.bool
};

DisciplineListItem.defaultProps = {
  average: {
    color: "",
    value: "-"
  },
  description: "",
  onClick: null,
  teacher: "",
  admissionStatus: {
    color: "",
    value: ""
  },
  expandedItem: false,
  evaluations: []
};

export default DisciplineListItem;
